document.addEventListener('DOMContentLoaded', function () {
  const sheet = document.getElementById('cart-bottom-sheet');
  const closeBtn = sheet.querySelector('.cart-bottom-sheet__close');
  const overlay = sheet.querySelector('.cart-bottom-sheet__overlay');
  var btnWrapper = document.getElementById('bundle-btn-wrapper');
  const headlineContainer = document.getElementById('cart-bottom-sheet-headline');

  // === REWARDS-Definitionen ===
  const rewards = {
    silver: [
      { minItems: 3, percent: 7, code:  'BUNDLE7SILVER' },
      { minItems: 5, percent: 12, code: 'BUNDLE12SILVER' },
      { minItems: 6, percent: 17, code: 'BUNDLE17SILVER' }
    ],
    gold: [
      { minItems: 3, percent: 10, code: 'BUNDLE10GOLD' },
      { minItems: 5, percent: 15, code: 'BUNDLE15GOLD' },
      { minItems: 6, percent: 20, code: 'BUNDLE20GOLD' }
    ]
  };

  function getReward(tier, itemCount) {
    if (!tier || !rewards[tier]) return null;
    let bestReward = null;
    for (let i = 0; i < rewards[tier].length; i++) {
      if (itemCount >= rewards[tier][i].minItems) {
        bestReward = rewards[tier][i];
      }
    }
    return bestReward;
  }

  // Debug: Zeigt den VIP Tier Name in der Konsole an
  console.log("VIP Tier Name:", window.smileVIPTier);

  function isAllowedMember() {
    if (!window.smileVIPTier) {
      console.log("[isAllowedMember] window.smileVIPTier ist nicht gesetzt oder leer:", window.smileVIPTier);
      return false;
    }
    const tier = window.smileVIPTier.toLowerCase();
    console.log("[isAllowedMember] Gefundener Tier-Name:", tier);
    const allowed = (tier === 'gold' || tier === 'silver');
    if (allowed) {
      console.log("[isAllowedMember] Zulässig: " + tier);
    } else {
      console.log("[isAllowedMember] NICHT zulässig: " + tier);
    }
    return allowed;
  }

  if (btnWrapper) {
    if (typeof window.smileVIPTier !== 'undefined' && window.smileVIPTier) {
      if (isAllowedMember()) {
        btnWrapper.style.display = 'flex';
        console.log("Button wird für Gold/Silver-Member angezeigt.");
      } else {
        btnWrapper.style.display = 'none';
        console.log("Button wird NICHT angezeigt (kein Gold/Silver-Member).");
      }
    } else {
      btnWrapper.style.display = 'none';
      console.log("Button wird NICHT angezeigt (nicht eingeloggt oder kein VIP Tier).");
    }
  }

  function lowerSlideCartZIndex() {
    var cartDrawer = document.querySelector('.slidecarthq');
    if (cartDrawer) {
      cartDrawer.style.zIndex = 999;
      console.log('SlideCart z-index auf 999 gesetzt');
    }
    var cartOverlay = document.querySelector('.slidecarthq-overlay');
    if (cartOverlay) {
      cartOverlay.style.zIndex = 998;
      console.log('SlideCart Overlay z-index auf 998 gesetzt');
    }
  }

  function restoreSlideCartZIndex() {
    var cartDrawer = document.querySelector('.slidecarthq');
    if (cartDrawer) {
      cartDrawer.style.zIndex = '';
      console.log('SlideCart z-index zurückgesetzt');
    }
    var cartOverlay = document.querySelector('.slidecarthq-overlay');
    if (cartOverlay) {
      cartOverlay.style.zIndex = '';
      console.log('SlideCart Overlay z-index zurückgesetzt');
    }
  }

  // Modal immer öffnen, wenn das Theme ein cart:change Event meldet
  document.addEventListener("cart:change", function(event) {
    if (typeof window.openCartBottomSheet === 'function') {
      console.log('🛒 cart:change erkannt – öffne Modal!');
      window.openCartBottomSheet();
    }
  });

  window.openCartBottomSheet = function () {
    if (!isAllowedMember()) {
      console.log('Das Modal wird nur Gold/Silver-Membern angezeigt.');
      return;
    }
    sheet.classList.add('active');
    sheet.classList.remove('hidden');
    loadCartProducts();
    lowerSlideCartZIndex();
  };

  // Schließen des Modals
  function closeSheet() {
    sheet.classList.remove('active');
    setTimeout(() => sheet.classList.add('hidden'), 300);
    restoreSlideCartZIndex();
  }

  // Schließen beim Klick aufs Kreuz und Overlay
  closeBtn.addEventListener('click', closeSheet);
  overlay.addEventListener('click', closeSheet);

  function loadCartProducts() {
    fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {
        let html = '';
        const excludedTags = ['exclude_bundle', 'kollektion_sonderangebot'];

        // Produkte samt Tags laden
        const productInfoPromises = cart.items.map((item) =>
          fetch(`/products/${item.handle}.js`)
            .then((res) => (res.ok ? res.json() : Promise.resolve({ tags: [] })))
            .then((productData) => ({
              ...item,
              tags: productData.tags || [],
            }))
            .catch(() => ({
              ...item,
              tags: [],
            }))
        );

        Promise.all(productInfoPromises).then((cartItemsWithTags) => {
          // 1. Ausschließen von nicht erlaubten Produkten (für Anzeige, Zählung, etc)
          const excludedItems = cartItemsWithTags.filter(item =>
            item.tags.some(tag => excludedTags.includes(tag))
          );
          const filteredItems = cartItemsWithTags.filter(item =>
            !item.tags.some(tag => excludedTags.includes(tag))
          );
          console.log('Excluded Items:', excludedItems);
          console.log('Filtered Items:', filteredItems);

          // 2. Flat-Array der erlaubten Produkte (Menge beachten!)
          const flatItems = [];
          filteredItems.forEach(item => {
            for (let i = 0; i < item.quantity; i++) {
              flatItems.push(item);
            }
          });

          const totalQuantity = flatItems.length;
          const maxSlots = 6;

          // 3. Produktkarten & Platzhalter
          for (let i = 0; i < maxSlots; i++) {
            if (flatItems[i]) {
              html += `
                <div class="cart-bottom-sheet-product">
                  <img src="${flatItems[i].image}" alt="${flatItems[i].title}">
                </div>
              `;
            } else {
              html += `
                <div class="cart-bottom-sheet-placeholder">
                  <span>–</span>
                </div>
              `;
            }
          }

          // Produkte HTML einsetzen
          const productsContainer = document.getElementById('cart-bottom-sheet-products');
          if (productsContainer) {
            productsContainer.innerHTML = html;
          }

          // === VIP TIER & Reward bestimmen ===
          const vipTier = (window.smileVIPTier || '').toLowerCase();
          const reward = getReward(vipTier, totalQuantity);
          const rules = rewards[vipTier] || [];

          // Ermittle, wie viele qualifizierte Produkte im Warenkorb sind
          const qualifiedCount = flatItems.length;
          console.log('Anzahl qualifizierter Produkte:', qualifiedCount);
          console.log('Reward:', reward);

          let nextReward = null;
          for (let i = 0; i < rules.length; i++) {
            if (qualifiedCount < rules[i].minItems) {
              nextReward = rules[i];
              break;
            }
          }
          console.log('Nächste Belohnung:', nextReward);

          let headline = '';
          if (nextReward) {
            const diff = nextReward.minItems - qualifiedCount;
            headline = `Füge noch ${diff} Produkt${diff > 1 ? 'e' : ''} hinzu und erhalte ${nextReward.percent}% Rabatt`;
            console.log(`Es fehlen noch ${diff} Produkte bis zur nächsten Belohnung (${nextReward.percent}%)`);
          } else if (rules.length && qualifiedCount >= rules[rules.length-1].minItems) {
            // Höchste Stufe erreicht!
            const bestReward = getReward(vipTier, qualifiedCount);
            headline = `Glückwunsch! Du erhältst ${bestReward.percent}% Rabatt.`;
          } else {
            headline = 'Lege Produkte in den Warenkorb und sichere dir Rabatte!';
          }
          if (headlineContainer) {
            headlineContainer.textContent = headline;
          }

          // === BUNDLE-BUTTON (nur EINMAL existieren lassen) ===
          let bundleButtonContainer = document.getElementById('cart-bottom-sheet-bundle-btn-container');
          if (!bundleButtonContainer) {
            bundleButtonContainer = document.createElement('div');
            bundleButtonContainer.id = 'cart-bottom-sheet-bundle-btn-container';
            bundleButtonContainer.style.display = 'flex';
            bundleButtonContainer.style.justifyContent = 'center';
            bundleButtonContainer.style.margin = '20px 0';
            productsContainer.parentNode.appendChild(bundleButtonContainer);
          }

          if (reward) {
            let rabattUrl = `/discount/${reward.code}?redirect=/cart`;
            bundleButtonContainer.innerHTML = `
              <a 
                href="${rabattUrl}" 
                class="cart-bottom-sheet-bundle-btn"
                style="
                  background: #00b97a; 
                  color: #fff; 
                  border-radius: 999px; 
                  font-weight: 700; 
                  font-size: 1.13rem;
                  padding: 16px 34px; 
                  text-decoration: none; 
                  margin-top: 16px; 
                  display: inline-block; 
                  transition: background 0.2s;"
              >
                Sichere dir jetzt ${reward.percent}% Rabatt!
              </a>
            `;
          } else {
            bundleButtonContainer.innerHTML = '';
          }

          // === Fehler-Animation für ausgeschlossene Produkte ===
          if (excludedItems.length > 0) {
            if (headlineContainer) {
              const originalHeadline = headlineContainer.innerHTML;
              headlineContainer.innerHTML = `Das Produkt "<b>${excludedItems[0].title}</b>" kann nicht zum Bundle hinzugefügt werden`;
              headlineContainer.classList.add('error');
              setTimeout(() => {
                headlineContainer.classList.remove('error');
                headlineContainer.innerHTML = originalHeadline;
              }, 1200);
            }
          }
        });
      });
  }
});
